import * as React from 'react';
import { theme } from 'components';

interface Props {
  address: string;
  toggleAdvancedSearch: (e: any) => void;
  search: (e: any) => void;
  handleChange: (key: string) => (e: any) => void;
  handleChecked: (key: string) => (e: any) => void;
}

const render = (props: Props) => (
    <form style={{ display: 'flex' }}>
      <div className="m-r-sm">
        <div className="input-group" style={{ width: '225px' }}>
          <input
            id="searchBox"
            type="text"
            className="form-control"
            value={props.address}
            onChange={props.handleChange('address')}
            placeholder="Address / MLS"
            autoFocus
            data-cy="search-address-mls"
          />
          <span className="input-group-btn">
            <button
              type="submit"
              onClick={props.search}
              className="btn btn-primary"
              data-cy="search-submit"
            >
              <i className="pe-7s-search fat" />
            </button>
          </span>
        </div>
      </div>
      <div className="m-r-sm" style={{ lineHeight: '34px' }}>
        <a
          style={{ fontSize: '12px', color: theme.gray8 }}
          onClick={props.toggleAdvancedSearch}
        >
          Advanced Search
        </a>
      </div>
    </form>
  );

export default render;
